import { CustomParagraph } from '../../../../models/slate-editor';
import { getHashtagsCount } from '../../../../helpers/getHashTagsCount';
import { EditorText } from '../../../../models/post-editor';
import { serializeText } from './serializer';
import { unescape } from 'lodash';

export const getTotalHashes = (texts: EditorText[], firstComment: CustomParagraph[]): [number, number] => {
  const maxHashtagsInTexts = texts.reduce((prev, current) => {
    const serializedText = unescape(serializeText(current.text));
    const hashtagsInText = getHashtagsCount(serializedText);
    return hashtagsInText > prev ? hashtagsInText : prev;
  }, 0);
  const hashtagsInComments = getHashtagsCount(serializeText(firstComment));
  return [maxHashtagsInTexts, hashtagsInComments];
};
